import { createContext, useEffect, useRef, useState } from "react";
import reqCidade from "../services/reqMultiTenant/reqCidade";
import Notification from "../components/toast";
import reqContaTipo from "../services/reqMultiTenant/reqContaTipo";
import reqCentroCusto from "../services/reqMultiTenant/reqCentroCusto";
import reqConta from "../services/reqMultiTenant/reqConta";
import reqFormaPgto from "../services/reqMultiTenant/reqFormaPgto";
import reqPermissoes from "../services/reqMultiTenant/reqPermissoes";
import { list } from "postcss";
import reqLog from "../services/reqMultiTenant/reqLog";
import { log } from "react-modal/lib/helpers/ariaAppHider";
import { checkVersionAndReload, fetchAppVersion } from "../util/action/versionWatcher";

const ContextGlobal = createContext({});

function ProviderGlobal(props) {
	const brazilStates = [
		{ uf: "AC", nome: "Acre" },
		{ uf: "AL", nome: "Alagoas" },
		{ uf: "AP", nome: "Amapá" },
		{ uf: "AM", nome: "Amazonas" },
		{ uf: "BA", nome: "Bahia" },
		{ uf: "CE", nome: "Ceará" },
		{ uf: "DF", nome: "Distrito Federal" },
		{ uf: "ES", nome: "Espírito Santo" },
		{ uf: "GO", nome: "Goiás" },
		{ uf: "MA", nome: "Maranhão" },
		{ uf: "MT", nome: "Mato Grosso" },
		{ uf: "MS", nome: "Mato Grosso do Sul" },
		{ uf: "MG", nome: "Minas Gerais" },
		{ uf: "PA", nome: "Pará" },
		{ uf: "PB", nome: "Paraíba" },
		{ uf: "PR", nome: "Paraná" },
		{ uf: "PE", nome: "Pernambuco" },
		{ uf: "PI", nome: "Piauí" },
		{ uf: "RJ", nome: "Rio de Janeiro" },
		{ uf: "RN", nome: "Rio Grande do Norte" },
		{ uf: "RS", nome: "Rio Grande do Sul" },
		{ uf: "RO", nome: "Rondônia" },
		{ uf: "RR", nome: "Roraima" },
		{ uf: "SC", nome: "Santa Catarina" },
		{ uf: "SP", nome: "São Paulo" },
		{ uf: "SE", nome: "Sergipe" },
		{ uf: "TO", nome: "Tocantins" },
	];

	const [citiesDataStorage, setCitiesDataStorage] = useState([]); // Armazena as cidades para não precisar fazer requisição toda vez que mudar o estado
	const [citiesData, setCitiesData] = useState([]);

	const [enterpriseData, setEnterpriseData] = useState({});
	const [logErrorsData, setLogErrorsData] = useState([]);

	const [categoryData, setCategoryData] = useState([]);
	const [bankData, setBankData] = useState([]);
	const [costCenterData, setCostCenterData] = useState([]);
	const [formPaymentData, setFormPaymentData] = useState([]);

	const [isTestVersion, setIsTestVersion] = useState(true);
	const [loading, setLoading] = useState(false);

	// Permissões do usuário
	const [listPermissionsData, setListPermissionsData] = useState({});
	const [modulopermitted, setModulopermitted] = useState([]);
	// const [statusEnterprise, setStatusEnterprise] = useState("");

	const [loadingPermissions, setLoadingPermissions] = useState(false);

	//versão do portal
	const [appVersion, setAppVersion] = useState("");
	useEffect(() => {
		const loadVersion = async () => {
			const v = await fetchAppVersion();
			setAppVersion(v);
		};

		loadVersion();
	}, []);

	const lastPermissionsFetchRef = useRef(0);
	const THREE_MIN_MS = 4 * 60 * 1000;
	async function fetchPermissions() {
		try {
			const now = Date.now();
			// se não for force e ainda não passou 3min, não vai no backend
			if (now - lastPermissionsFetchRef.current < THREE_MIN_MS) {
				return;
			}

			lastPermissionsFetchRef.current = now;

			setLoadingPermissions(true);

			const response = await reqPermissoes.listPermission(); // token via interceptor

			console.log(`[permissions/validate] ${new Date().toLocaleTimeString()} · ${response.data.length} linha(s)`);
			console.table(
				response.data.map(({ modulo, nome_produto, status_modulo, data_expiracao, dias_restantes }) => ({
					modulo,
					nome_produto,
					status_modulo,
					data_expiracao,
					dias_restantes,
				})),
			);

			const responseApps = response.data.map((item) => ({
				modulo: item.modulo,
				status: item.status_modulo,
				dataExpiracao: item.data_expiracao,
				dias_restantes: item.dias_restantes,
			}));

			setModulopermitted(responseApps);
			setListPermissionsData(response.data[0] || {});
		} catch (error) {
			// se der erro, zera estados para forçar login/feedback na UI
			setModulopermitted([]);
			setListPermissionsData({});
			console.error(error);
		} finally {
			setLoadingPermissions(false);
		}
	}

	useEffect(() => {
		const enterpriseId = { id_empresa: listPermissionsData?.id_empresa };

		// 👉 se ainda não logou / não tem empresa, não faz nada
		if (!enterpriseId?.id_empresa) {
			return;
		}

		setEnterpriseData(enterpriseId);

		const loadLogs = async () => {
			try {
				const responseLogErrors = await reqLog.listPaginate();
				setLogErrorsData(responseLogErrors.data);
			} catch (err) {
				console.error("Erro ao buscar logs:", err);
			}
		};

		// função que roda a cada 3 minutos
		const tick = async () => {
			if (document.visibilityState !== "visible") return;
			if (!navigator.onLine) return;

			// 1) atualiza logs
			await loadLogs();

			// 2) verifica se existe nova versão
			await checkVersionAndReload({
				autoReload: true,
				// se no futuro quiser mostrar modal ao invés de recarregar direto:
				// onNewVersion: ({ currentVersion, newVersion }) => { ... }
			});
		};
		// roda uma vez ao montar
		tick();
		window.__szLogsTimer = setInterval(tick, THREE_MIN_MS);

		return () => {
			if (window.__szLogsTimer) clearInterval(window.__szLogsTimer);
		};
	}, [listPermissionsData?.id_empresa]);

	//#region Pesquisar Cidades
	const fetchCities = async () => {
		try {
			setLoading(true);
			if (citiesData?.length === 0) {
				const responseCidade = await reqCidade.listar();

				setCitiesData(responseCidade.data);
			}
		} catch (error) {
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	const fetchCitiesByUf = async (uf) => {
		try {
			setLoading(true);
			let responseCities = [];

			const existingCities = citiesDataStorage.filter((city) => city.uf === uf);

			if (existingCities.length > 0) {
				responseCities = existingCities;
			} else {
				const response = await reqCidade.listState(uf);
				responseCities = response.data;

				setCitiesDataStorage((prevCitiesStorage) => [...prevCitiesStorage, ...responseCities]);
			}
			setCitiesData(responseCities);

			return responseCities;
		} finally {
			setLoading(false);
		}
	};
	//#endregion

	//#region Pesquisar categoria banco e centro de custo

	const fetchCategory = async (tipo) => {
		try {
			setLoading(true);

			const response = await reqContaTipo.listAll();

			if (response?.data) setCategoryData(response.data);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	const fetchCostCenter = async () => {
		try {
			setLoading(true);

			const response = await reqCentroCusto.listAll();
			if (response?.data) setCostCenterData(response.data);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	const fetchBank = async () => {
		try {
			setLoading(true);

			const response = await reqConta.listAll();
			if (response?.data) setBankData(response.data);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	const fetchFormPayment = async () => {
		try {
			setLoading(true);

			const response = await reqFormaPgto.listAll();
			if (response?.data) setFormPaymentData(response.data);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	//#endregion

	return (
		<ContextGlobal.Provider
			value={{
				appVersion,

				listPermissionsData,
				setListPermissionsData,

				enterpriseData,
				logErrorsData,

				// statusEnterprise,
				// setStatusEnterprise,

				modulopermitted,
				setModulopermitted,

				citiesData,
				fetchCities,
				fetchCitiesByUf,

				isTestVersion,
				setIsTestVersion,

				categoryData,
				fetchCategory,

				bankData,
				fetchBank,

				costCenterData,
				fetchCostCenter,

				formPaymentData,
				fetchFormPayment,

				lastPermissionsFetchRef,
				fetchPermissions,

				brazilStates,
				// stateBrazilSelected,
				// setStateBrazilSelected,
				loadingCities: loading,
				loadingPermissions,
			}}
		>
			{props.children}
		</ContextGlobal.Provider>
	);
}

export { ContextGlobal, ProviderGlobal };
